var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCBB-ADMIN-(Web)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D\\xE9tails-client---Prestations-contractualis\\xE9es",
    transform: "translate(-109.000000, -611.000000)",
    fill: "#172134",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file",
    transform: "translate(109.000000, 611.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0000386,6 L18.0000386,18.9930534 C18.0009151,19.1243035 17.9760151,19.2545786 17.92659,19.3762287 C17.877165,19.4979538 17.8042649,19.6086539 17.7120898,19.702179 C17.6198398,19.7957041 17.5101147,19.8701042 17.3891396,19.9212542 C17.2681645,19.9723292 17.1383394,19.9991043 17.0070143,20 L0.993000832,20 C0.729813612,20 0.4773919,19.8955292 0.291196744,19.709529 C0.105001588,19.5235289 0.000265041972,19.2712287 0,19.0079784 L0,0.992003332 C0,0.455002881 0.448999876,0 1.00200084,0 L11.9970101,0 L18.0000386,6 Z M15.9999884,7.00000418 L11.0000342,7.00000418 L11.0000342,2.00000418 L2.00000418,2.00000418 L2.00000418,17.9999776 L15.9999884,17.9999776 L15.9999884,7.00000418 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon_file.39b286e53723d77efef13cff29b29a68.svg";
export { ForwardRef as ReactComponent };